import { InformationCircleIcon } from '@heroicons/react/24/outline';
import Button from 'common/components/Button/Button';
import Header from 'common/components/Header/Header';
import useRouter from 'common/hooks/use-router';
import useAuth from 'common/hooks/useAuth';
import { useTranslation } from 'react-i18next';

function NoProfile() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { navigate } = useRouter();
  return (
    <div className="mx-auto max-w-full py-6 px-6 text-slate-500">
      <Header
        title={t('titlePages.noProfile')}
        subTitle={t('titleLegends.noProfile')}
        Icon={InformationCircleIcon}
      />

      <div className="flex gap-3 pb-8 pt-4">
        <div className="white-box w-full flex flex-col items-center justify-start min-h-[250px]">
          <div className="flex flex-row justify-center items-center mt-4 w-full">
            <InformationCircleIcon className="w-16 h-16 text-fourth mt-1" />

            <div className="flex flex-col ml-8 text-left text-primary max-w-[700px]">
              <p className="" style={{ whiteSpace: 'pre-line' }}>
                {t('error.noProfile')}
              </p>
            </div>
          </div>
          <div className="flex justify-center mt-16 mb-8">
            <Button
              title={t('actions.addInformations')}
              onClick={() => navigate(`/mediators/add?userId=${user?.id}`)}
              icon="PlusCircleIcon"
              type="primary"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoProfile;
